/**
 * @module components/YAxisSetting/DualYAxisSwitch
 * @description 双 Y 轴开关行（受控，状态由 YAxisSetting/index 管理）
 */

import React from 'react';
import { useIntl } from 'umi';
import { Bubble, Switch } from 'tea-component';

interface IDualYAxisSwitchProps {
  value: boolean;
  disabled?: boolean;
  onChange: (enabled: boolean) => void;
}

const DualYAxisSwitch: React.FC<IDualYAxisSwitchProps> = ({
  value,
  disabled = false,
  onChange,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className="dbl-chart-setting-row">
      <span className="dbl-lable-gray-font">
        {formatMessage({ id: 'dbl_chart_dual_y_axis' })}
      </span>
      <Bubble
        placement="top-end"
        placementOffset={[10, 10]}
        dark
        content={
          disabled
            ? formatMessage({ id: 'dbl_chart_dual_y_axis_min_metric_tip' })
            : ''
        }
      >
        <span>
          <Switch value={value} disabled={disabled} onChange={onChange} />
        </span>
      </Bubble>
    </div>
  );
};

export default React.memo(DualYAxisSwitch);
